// Peças da análise de mercado compartilhadas entre as abas (natureza, fontes sob demanda, legenda).
import { useState } from 'react';
import { marketApi, NATURE_CLASS, NATURE_LABEL } from '../../data/market';

export const Nature = ({ n }: { n: string | null | undefined }) => (n ? <span className={`nature ${NATURE_CLASS[n] ?? ''}`}>{NATURE_LABEL[n] ?? n}</span> : null);

/** Fontes de um item: carrega sob demanda as evidências citadas (url, trecho, natureza). */
export function Sources({ analysisId, runId, ids, emptyText = 'Sem fonte citada' }: { analysisId: string; runId: string; ids: string[]; emptyText?: string }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<Array<Record<string, any>> | null>(null);  
  if (!ids.length) return <span className="cell-sub">{emptyText}</span>;
  const toggle = async () => {
    setOpen((o) => !o);
    if (!items) setItems((await marketApi.evidences(analysisId, { runId, ids }).catch(() => ({ items: [] }))).items);
  };
  return (
    <div className="sources">
      <button type="button" className="link-btn" onClick={toggle} aria-expanded={open}>{ids.length} fonte(s)</button>
      {open && <ul>{(items ?? []).map((e) => <li key={e.id}><Nature n={e.nature} /> <a href={e.url ?? undefined} target="_blank" rel="noopener noreferrer nofollow">{e.title}</a>{e.excerpt && <q>{e.excerpt}</q>}</li>)}{items === null && <li>Carregando…</li>}</ul>}
    </div>
  );
}

export const Legend = () => <p className="legend"><Nature n="FATO" /> dito por fonte primária · <Nature n="INDICIO" /> sugerido por fonte · <Nature n="HIPOTESE" /> inferência ainda não comprovada</p>;
